<template>
    <div class="page">
        <div class="top-section" :class="{pb:fields.kind}">
            <van-swipe :autoplay="3000" class="swipe" v-if="!fields.kind" style="width: 100%;height:100%;">
                <van-swipe-item v-for="(image, index) in fields.images" :key="`x${index}`"
                                style="text-align:center;">
                    <img v-lazy="image" style="width:100%;height:100%;object-fit: cover;"/>
                </van-swipe-item>
            </van-swipe>
            <video width="100%" height="100%" controls v-else>
                <source :src="fields.video" type="video/mp4">
            </video>
            <div class="info">
                <img :src="fields.showUserPortrait" class="logo" alt="">
                <span class="name">{{fields.showUserName}}</span>
            </div>
        </div>
        <div class="content">
            <div class="tags">
                    <van-tag class="mr" size="medium">{{fields.category.value}}</van-tag>
                    <van-tag class="mr" v-for="item in fields.topicList" :key="item.showNo"
                             size="medium" color="#F2FFFC" text-color="#00A680">{{item.topicName}}</van-tag>
            </div>
            <h6 class="title">{{fields.contentTxt}}</h6>
            <p>
                <van-tag v-if="fields.hotFlag" class="mr" size="medium" color="#1D2023" text-color="#E3A761">热帖</van-tag>
                <van-tag v-if="fields.topFlag" class="mr" size="medium" color="#FFF1F0" text-color="#F5222D">精华</van-tag>
            </p>
            <div class="btm">
                <span>{{fields.address}}</span>
                <span>{{showTime(fields.createTime)}}</span>
            </div>
        </div>
        <div class="fixedBottom">
            <div class="btn" id="downloadButton" @click="toDownload">
                <p>点击查看更多</p>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import {Lazyload} from 'vant';
  import moment from "moment"

  Vue.use(Lazyload);
  export default {
    data() {
      return {
        moment,
        showNo: '',
        fields: {
            hotFlag:0,
            topFlag:0,
            category:{},
            images:[],
            showUserPortrait:''
        },
      }
    },
    created() {
      this.showNo = this.$route.query && this.$route.query.showNo
        if(this.showNo){
            this.getFieldsShow()
        }else{
            this.$notify('未查询到showNo!')
        }
    },
    methods: {
      //获取问答详情
      getFieldsShow() {
          let { showNo } = this
          this.$api.getFieldsShow({showNo}).then(res=>{
              this.fields = res.data
          })
      },
      //跳转下载
      toDownload() {
            // eslint-disable-next-line no-undef
            var data = OpenInstall.parseUrlParams();
            // eslint-disable-next-line no-undef
            new OpenInstall({
                /*appKey必选参数，openinstall平台为每个应用分配的ID*/
                appKey : "pzm0rx",
                /*可选参数，自定义android平台的apk下载文件名；个别andriod浏览器下载时，中文文件名显示乱码，请慎用中文文件名！*/
                //apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
                /*可选参数，是否优先考虑拉起app，以牺牲下载体验为代价*/
                //preferWakeup:true,
                /*自定义遮罩的html*/
                //mask:function(){
                //  return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
                //},
                /*openinstall初始化完成的回调函数，可选*/
                onready : function() {
                    var m = this, button = document.getElementById("downloadButton");
                    button.style.visibility = "visible";

                    /*在app已安装的情况尝试拉起app*/
                    m.schemeWakeup();
                    /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
                    button.onclick = function() {
                        m.wakeupOrInstall();
                        return false;
                    }
                }
            }, data);
        },
      showTime(time){
            if(!time){
                return
            }
            let now = Date.now()
            let createTime = new Date(time.replace(/-/g,'/')).getTime()
            let differ = now - createTime
            //计算出相差天数
            var days = Math.floor(differ/(24*3600*1000))
            //计算出小时数
            var leave1 = differ % (24*3600*1000)    //计算天数后剩余的毫秒数
            var hours = Math.floor(leave1/(3600*1000))
            //计算相差分钟数
            var leave2 = leave1 % (3600*1000)        //计算小时数后剩余的毫秒数
            var minutes = Math.floor(leave2/(60*1000))

            if(differ <= (1*60*1000) ){  //小于1分钟
                return '刚刚'
            }else if(days === 0 && hours === 0 && minutes < 60){ // *分钟前
                return `${minutes}分钟前`
            }else if(days < 1){ // *分钟前
                return `${hours}小时前`
            }else if(days === 1){ // *分钟前
                return `昨天`
            }else if(days === 2){ // *分钟前
                return `前天`
            }else{
                return `${days}天前`
            }
        }
    }
  }
</script>

<style lang="scss" scoped>
    @import '@/styles/tjshow/index';
</style>
